import React, { useState } from 'react'
import Contact from './style'
import SectionTitle from './Components/SectionTitle'
import { Col, Container, Row, Spinner } from 'react-bootstrap'
import { StaticImage as Img } from "gatsby-plugin-image";
import client from "~data/contentful"
import 'regenerator-runtime/runtime'

const generateUuidv4 = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

export default function ContactOne() {

  const [success, setSuccess] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [requestId, setRequestId] = useState('');
  const [error, setError] = useState('');

  const isEmail = (email) => {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  };

  const isPhone = (phone) => {
    const re = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/;
    return re.test(phone);
  };

  const validateForm = (values) => {
    const errors = {};
    if (!values.message) {
      errors.message = 'Please enter your message';
    }
    if (isEmail(values.email) === false) {
      errors.email = 'Please enter a valid email';
    }
    if (isPhone(values.phone) === false) {
      errors.phone = 'Please enter a valid phone number';
    }
    return errors;
  };

  const submitContact = (e) => {
    e.preventDefault()
    const values = {
      email: document.querySelector('#email').value,
      message: document.querySelector('#message').value,
      phone: document.querySelector('#phone').value,
    }
    const errors = validateForm(values);
    if (Object.keys(errors).length > 0) {
      setError(errors);
      return;
    }
    setIsSubmitting(true)
    const uuid = generateUuidv4()
    client.getSpace('s5z6ubc8fuk6')
      .then((space) => space.getEnvironment('master'))
      .then((environment) => environment.createEntryWithId('contactUs', uuid, {
        fields: {
          message: {
            'en-US': values.message
          },
          phone: {
            'en-US': values.phone
          },
          email: {
            'en-US': values.email
          }
        }
      }))
      .then((entry) => {
        client.getSpace('s5z6ubc8fuk6')
          .then((space) => space.getEnvironment('master'))
          .then((environment) => environment.getEntry(entry.sys.id))
          .then((entry) => entry.publish())
          .then((entry) => {
            setSuccess(true)
            setRequestId(entry.sys.id)
          })
          .catch(() => {
            setSuccess(false)
            setIsSubmitting(false)
          })
      })
      .catch(() => {
        setSuccess(false)
        setIsSubmitting(false)
      })
  }

  const renderForm = () => {
    return (
      <div>
        <Contact.Box >
          <SectionTitle
            title="Send a message"
            text="Let us know how we can help you. We are here for you."
            subTitleProps={{ mb: "10px" }}
            titleProps={{ mb: "10px", as: "h2" }}
            mb="50px" />
        </Contact.Box>
        <Contact.From>
          <form action="./">
            <Row>
              <Col xs="12" className="col-lg-6 mb-4">
                <div className="form-floating">
                  <input className="form-control" placeholder="Leave a comment here" id="email" />
                  <label htmlFor="floatinginput">Your Email</label>
                </div>
                {error.email && <Contact.Error>{error.email}</Contact.Error>}
              </Col>
              <Col xs="12" className="col-lg-6 mb-4">
                <div className="form-floating">
                  <input className="form-control" placeholder="Leave a comment here" id="phone" />
                  <label htmlFor="floatinginput2">Phone number</label>
                </div>
                {error.phone && <Contact.Error>{error.phone}</Contact.Error>}
              </Col>
              <Col xs="12" className="col-lg-12">
                <div className="form-floating">
                  <textarea className="form-control" placeholder="Leave a comment here" id="message" />
                  <label htmlFor="floatingTextarea3">Your Message Here </label>
                </div>
                {error.message && <Contact.Error>{error.message}</Contact.Error>}
              </Col>
              <Col xs="12" className="col-lg-12">
                <Row className="align-items-center mt-3">
                  <div className="col-md-8 col-lg-7 col-md-6 col-xl-8 pt-3">
                    <div className="form-check d-flex align-items-center">
                      <label className="form-check-label" htmlFor="flexCheckDefault">
                        Your email address will not be published. Required fields are marked *
                      </label>
                    </div>
                  </div>
                  <Col xs="12" className="col-md-4 col-lg-5 col-xl-4 text-md-end pt-3">
                    <Contact.Button onClick={submitContact} disabled={isSubmitting}>
                      {isSubmitting ? <Spinner animation="border" variant="light" /> : 'Send Message'}
                    </Contact.Button>
                  </Col>
                </Row>
              </Col>
            </Row>
          </form>
        </Contact.From>
      </div>
    )
  }

  const successMessage = () => {
    return (
      <div>
        <Contact.Box >
          <SectionTitle
            title={`Thank you for contacting us.`}
            text={`Our team will get in touch with you shortly. Your support request id is ${requestId}`}
            subTitleProps={{ mb: "10px" }}
            titleProps={{ mb: "10px", as: "h2" }}
            mb="50px" />
        </Contact.Box>
        <div>
          <Img src="../../../../assets/image/project-management/thankyou.png" alt="heroimg" placeholder="blurred" />
        </div>
      </div>
    )
  }

  return (
    <Contact backgroundColor="#f3f4f6">
      <Container>
        <Row>
          <Col className="col-xl-7 col-lg-7">
            {success ? successMessage() : renderForm()}
          </Col>
          <Col xs="12" className="col-xl-5 col-lg-5">
            <Contact.WidgetsBox className="contact-widget-box">
              <Contact.WidgetsBoxTitle as="h2">Get In Touch.</Contact.WidgetsBoxTitle>
              <Contact.WidgetsBoxText as="p">Let us know how we can help you. We are here for you.</Contact.WidgetsBoxText>
              <Row>
                <Col xs="12" className="col-lg-12 col-sm-6">
                  <Contact.Widgets>
                    <Contact.WidgetsIcon>
                      <i className="fas fa-map-marker-alt" />
                    </Contact.WidgetsIcon>
                    <Contact.WidgetsBoxBody>
                      <Contact.WidgetsTitle as="h3">Visit us :</Contact.WidgetsTitle>
                      <Contact.WidgetsText as="p">Level 2, 11 York street<br className="d-block" /> Sydney, Australia</Contact.WidgetsText>
                    </Contact.WidgetsBoxBody>
                  </Contact.Widgets>
                </Col>
                <Col xs="12" className="col-lg-12 col-sm-6 active">
                  <Contact.Widgets>
                    <Contact.WidgetsIcon className="active">
                      <i className="fas fa-envelope" />
                    </Contact.WidgetsIcon>
                    <Contact.WidgetsBoxBody>
                      <Contact.WidgetsTitle as="h3">Mail us :</Contact.WidgetsTitle>
                      <Contact.WidgetsText as="p">hello@docpile.io</Contact.WidgetsText>
                    </Contact.WidgetsBoxBody>
                  </Contact.Widgets>
                </Col>
                <Col xs="12" className="col-lg-12 col-sm-6">
                  <Contact.Widgets>
                    <Contact.WidgetsIcon>
                      <i className="fas fa-phone-alt" />
                    </Contact.WidgetsIcon>
                    <Contact.WidgetsBoxBody>
                      <Contact.WidgetsTitle as="h3">Call us :</Contact.WidgetsTitle>
                      <Contact.WidgetsText as="p">+61 (405) 925 085</Contact.WidgetsText>
                    </Contact.WidgetsBoxBody>
                  </Contact.Widgets>
                </Col>
              </Row>
            </Contact.WidgetsBox>
          </Col>
        </Row>
      </Container>
    </Contact>

  )
}